<template>
  <hm-content title>
    <div class=" item-center">
      <el-radio-group
        class="mb10 flex"
        size="small"
        v-model="switchType"
        @change="switchTab"
      >
        <el-radio-button label="detail">明细</el-radio-button>
        <el-radio-button label="statistics">统计</el-radio-button>
      </el-radio-group>

      <div class="table-panel flex flex-end">
        <el-select
          v-model="searchCondition.employeeIdList"
          placeholder="请选择技师姓名"
          class="mr10"
          size="small"
          filterable
          clearable
          v-show="this.switchType === 'detail'"
        >
          <el-option
            :label="item.realName"
            :value="item.employeeId"
            v-for="(item, index) in shopEmpList"
            :key="index"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="searchCondition.shopIdList"
          placeholder="请选择服务门店"
          class="mr10"
          size="small"
          filterable
          clearable
        >
          <el-option
            :label="item.shopName"
            :value="item.shopId"
            v-for="(item) in ruleForm.shopRelModelList"
            :key="item.shopId"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="searchCondition.serviceStatus"
          placeholder="请选择订单状态"
          class="mr10"
          size="small"
          filterable
          clearable
          v-show="this.switchType === 'detail'"
        >
          <el-option
            :label="item.name"
            :value="item.status"
            v-for="(item, index) in serviceStatus"
            :key="index"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchCondition.queryDate"
          type="datetimerange"
          align="right"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class="mr10 time"
          v-show="this.switchType === 'detail'"
          style="width: 340px"
        ></el-date-picker>

        <!-- <el-select
          v-model="searchCondition.timeQuantumId"
          placeholder="请选择预约时段"
          class="mr10"
          size="small"
          filterable
          clearable
          v-show="this.switchType === 'detail'"
        >
          <el-option
            :label="item.startTimeQuantum + '-' + item.endTimeQuantum"
            :value="item.id"
            v-for="(item, index) in ruleForm.timeQuantumRelModelList"
            :key="index"
          >
          </el-option>
        </el-select> -->

        <el-input
          style="width:260px"
          class="mr10"
          size="small"
          placeholder="请输入预约单号/会员姓名/会员手机号"
          v-model="searchCondition.queryKeyWord"
          v-show="this.switchType === 'detail'"
          clearable
        ></el-input>

        
        <el-cascader
          v-model="searchCondition.categorizationServiceDropDown"
          :options="serviceTypeRelModelList"
          size="small"
          :props="{ checkStrictly: true }"
          v-show="this.switchType === 'detail'"
          clearable
          placeholder="请选择分类服务"
          style="margin-right: 10px">
        </el-cascader>

        <el-cascader
          v-model="searchCondition.resultLevelVal"
          :options="resultLevel"
          size="small"
          :props="{ checkStrictly: true }"
          v-show="this.switchType === 'statistics'"
          clearable
          placeholder="请选择分类服务"
          style="margin-right: 10px">
        </el-cascader>
        
        <el-button class="mr10" size="small" type="primary" @click="queryList(false)" v-show="this.switchType === 'detail'"
          style="margin-right: 0 !important">查询</el-button
        >
        <el-button class="mr10" size="small" type="primary" @click="queryStatisticsList" v-show="this.switchType === 'statistics'"
          >查询</el-button
        >
        <el-button
          class="mr10"
          size="small"
          type="primary"
          @click="output"
          v-show="this.switchType === 'detail'"
          :loading="isOutputing"
          >导出
        </el-button>
      </div>
    </div>
    <div class="flex flex-between item-center">
      <el-radio-group
        class="mt10"
        size="small"
        v-model="queryType"
        @change="queryTab"
        v-show="this.switchType === 'statistics'"
      >
      <el-radio-button
        :label="item.label"
        v-for="(item, index) in queryTypeList"
        :key="index"
        >{{ item.name }}</el-radio-button
      >
      </el-radio-group>
    </div>
    <div class="detail mt20" v-show="this.switchType === 'detail'">
      <el-table
        stripe
        border
        :data="detailList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serviceSn"
          label="预约单号"          
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机号"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="serviceType"
          label="项目分类"
        ></el-table-column>


        <el-table-column
          header-align="center"
          align="center"
          prop="serviceName"
          label="服务名称"
        ></el-table-column>


        <el-table-column
          header-align="center"
          align="center"
          prop="subscribeDate"
          label="预约时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serviceTimeQuantum"
          label="预约时段"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.startTimeQuantum }}-{{
                scope.row.endTimeQuantum
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realname"
          label="技师姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="phone"
          label="技师手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="服务门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="applyNum"
          label="预约人数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="订单状态"
          prop="serviceStatus"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.serviceStatus === 'success'" class="success"
              >已完成</span
            >
            <span v-if="scope.row.serviceStatus === 'signUp'" class="blue"
              >已预约</span
            >
            <span v-if="scope.row.serviceStatus === 'overdue'" class="gray"
              >已过期</span
            >
            <span v-if="scope.row.serviceStatus === 'cancel'" class="danger"
              >已取消</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="是否核销"
          prop="chargeStatus"
          key="sendState"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.chargeStatus === 'no'" style="color: #ff7f10">
              <el-button
                type="text"
                size="small"
                @click="verification(scope.row)"
                class="blue"
                 v-if="scope.row.serviceStatus === 'signUp'"
                >核销</el-button
              >
            </div>
            <div v-else>
              <el-button type="text" size="small" disabled class="success"
                >已核销</el-button
              >
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
            <el-tooltip class="item" content="查看报名详情" placement="top">
              <div class="pointer mr10" @click="toDetails(scope.row.id)">
                <span class="hmicon icon-chakan blue"></span>
              </div>
            </el-tooltip>


            <p  v-if="scope.row.serviceStatus === 'signUp'" @click="cancel(scope.row)" style="cursor: pointer; color: #0862EC; margin-right: 10px;">取消</p>
            <p  v-if="scope.row.serviceStatus === 'signUp'"  @click="verification(scope.row)" style="cursor: pointer; color: #0862EC;">核销</p>

            <!-- <el-tooltip
              class="item mr10"
              content="核销"
              placement="top"
              v-if="scope.row.serviceStatus === 'signUp'"
            >
              <div class="pointer" @click="verification(scope.row.id)">
                <span class="hmicon icon-xingzhuanggaizhang blue"></span>
              </div>
            </el-tooltip> -->


            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="statistics mt20" v-show="this.switchType === 'statistics'">
      <el-table
        stripe
        border
        :data="statisticsList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        
        <el-table-column
          header-align="center"
          align="center"
          prop="strName"
          :label="queryTypeName"
        ></el-table-column>


        <el-table-column
          header-align="center"
          align="center"
          label="分类"
          prop="serviceType"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="服务"
          prop="serviceName"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="applyNum"
          label="预约次数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="chargeNum"
          label="已核销次数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cancelNum"
          label="已取消次数"
        ></el-table-column>
        
      </el-table>
    </div>
    <div class="hm-pagination mb20">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>

    <el-dialog
      title="报名详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
  
     <el-table
      :data="detailsList"
      style="width: 100%"
      stripe
      border>

      <template v-for="column in columns">
        <el-table-column
          :key="column.prop"
          :label="column.label"
          :prop="column.prop"
        >
        </el-table-column>
      </template>

    </el-table>


     </el-dialog>


     <!-- 核销弹窗 -->
     <el-dialog
        title="核销预约"
        :visible.sync="verificationPopUpWindow"
        width="30%"
        >
        
          <div class="verification">
            <h3>请确认一下预约信息</h3>
            <div class="table mt10">
                <div class="list active" >
                  <div class="list_title flex">
                    <img src="https://redpackge.oss-cn-hangzhou.aliyuncs.com/static/fuwu/Frame%20(2).svg">
                    <h3>{{ verificationListPopUps.shopName }}</h3>
                  </div>
                  <div class="name_mobile flex">
                    <img src="https://redpackge.oss-cn-hangzhou.aliyuncs.com/static/fuwu/Frame%20(3).svg">
                    <p class="username">{{ verificationListPopUps.memberName }}</p>
                    <p class="cellPhone">{{ verificationListPopUps.memberMobile }}</p>
                  </div>

                  <p class="number">单号：{{ verificationListPopUps.serviceSn }}</p>
                  <p class="time">时段:{{ verificationListPopUps.subscribeDate }}（{{getDayOfWeek(verificationListPopUps.subscribeDate)}}）{{verificationListPopUps.startTimeQuantum}}-{{ verificationListPopUps.endTimeQuantum}}</p>

                  <ul>
                    <li>
                      <div class="th">{{ verificationListPopUps.serviceType }}</div>
                      <div class="tr">类型</div>
                    </li>
                    <li>
                      <div class="th">{{ verificationListPopUps.serviceName }}</div>
                      <div class="tr">预约服务</div>
                    </li>
                    <li>
                      <div class="th">{{ verificationListPopUps.realname}}</div>
                      <div class="tr">服务技师</div>
                    </li>
                    <li>
                      <div class="th">{{ verificationListPopUps.applyNum }}人</div>
                      <div class="tr">预约人数</div>
                    </li>
                  </ul>
                </div>
              </div>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="verificationPopUpWindow = false">取 消</el-button>
          <el-button size="small" type="primary" @click="verificationPopUpWindowConfirm">确 认</el-button>
        </span>
      </el-dialog>



    <!-- 取消弹窗 -->
    <el-dialog
      title="填写取消原因"
      :visible.sync="cancelThePopUpWindow"
      width="30%"
      >

      <div class="cancel_box">
        <h2>请选择取消原因</h2>
        <ul>
          <template v-if="aListOfReasonsForCancellation && aListOfReasonsForCancellation.length > 0">
            <li v-for="(v, index) in aListOfReasonsForCancellation" :class="{active: v.state}" :key="index" @click="cancelReason(index)">{{v.name}}</li>
            <textarea v-show="isShowReason" v-model="otherVal" placeholder="请填写取消原因" id="" cols="30" rows="5"></textarea>
          </template>
        </ul>



      </div>



      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelThePopUpWindow = false">取 消</el-button>
        <el-button type="primary" @click="cancelTheSubmission">确 定</el-button>
      </span>
    </el-dialog>




  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      otherVal: '',
      isShowReason: false,
      aListOfReasonsForCancellation:[],
      cancelThePopUpWindow: false,
      verificationPopUpWindow: false,
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
       // 转换后的表格数据
      tableData: [],
      columns: [],
      serviceTypeRelModelList:[],
      resultLevel:[],
      storeCode:'',
      detailsList: [],
      shopEmpList: [],
      projectId: "",
      ruleForm: {},
      detailTotal: 4,
      detailCurrentPage: 1,
      detailPageSize: 10,
      currentPage: 1,
      pageSize: 10,
      total: 4,
      paramsExport:{
        pageNo: 1,
        pageSize: 99999
      },
      dynamicColumns: [],
      searchCondition: {},
      serviceTypeList: [],
      isOutputing: false,
      switchType: "detail",
      detailSwitchType: "technician",
      queryType: "shop",
      queryTypeName:"门店",
      dialogVisible: false,
      cancelRow: {},
      serviceStatus: [
        {
          status: "signUp",
          name: "已预约",
        },
        {
          status: "success",
          name: "已完成",
        },
        {
          status: "overdue",
          name: "已过期",
        },
        {
          status: "cancel",
          name: "已取消",
        },
      ],
      detailList: [],
      statisticsList: [],
      technicianList: [],
      verificationListPopUps: {},
      queryTypeList: [
        {
          label: "shop",
          name: "门店",
        },
        {
          label: "emp",
          name: "技师",
        },
        {
          label: "subscribeDate",
          name: "预约日期",
        },
        {
          label: "timeQuantum",
          name: "时段",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;

    console.log("this.$route.query.id:", this.$route.query.id);
    this.projectId = this.$route.query.id;

    this.queryServiceRestorationProjectEmpList();
    this.queryServiceRestorationProjectShopList();
   
  },
  mounted() {

    // this.queryServiceRestorationTypeList();
    // this.getServiceRestorationProjectInfo();
    this.queryList();
    this.queryServiceRestorationProjectTimeQuantumList();
    this.getServiceRestorationTypeNodeListByStoreCode();
  },
  methods: {

    async cancelTheSubmission(){
      let cancelReason = "";
      let whetherOrNotToExecute = true;
      this.aListOfReasonsForCancellation.forEach(v => {
        if(v.state){
          cancelReason += v.name +"|";
        } 
        if(v.name == '其他' && !this.otherVal && v.state){
          whetherOrNotToExecute = false;
        }
      });

      if(!cancelReason){
        this.$message({
          message: "请选择取消原因",
          type: "error"
        });
        return;
      }
      if(!whetherOrNotToExecute) {
        this.$message({
          message: "请输入其他原因",
          type: "error"
        });
        return;
      }

      cancelReason += this.otherVal;

      const { result } = await this.$store.dispatch("cancelServiceProject", {
        id: this.cancelRow.id,
        cancelReason
      });
      if(result && result === "success"){
        this.$message({
          message: "取消成功",
          type: "success"
        });
        this.queryList();
        this.cancelThePopUpWindow = false;
      }

    },
    cancelReason(index){
      if(this.aListOfReasonsForCancellation[index].state){
        this.aListOfReasonsForCancellation[index].state = false;
        if(this.aListOfReasonsForCancellation[index].name == '其他'){
          this.isShowReason = false;
        }
      }else {
        this.aListOfReasonsForCancellation[index].state = true;
        if(this.aListOfReasonsForCancellation[index].name == '其他'){
          this.isShowReason = true;
        }
      }
    },
    // 取消
    async cancel(row){
      this.cancelRow = row;
      this.otherVal = "";
      this.aListOfReasonsForCancellation.forEach(v => {
        v.state = false;
      });
      this.cancelThePopUpWindow = true;
      const { result } = await this.$store.dispatch("getModelByParamCodeCancel", {
        paramCode: 'reservation_cancel_reason',
        storeCode: this.storeCode,
      });
      if(result && result.paramValue){
        result.paramValue= JSON.parse(result.paramValue);
        let aListOfReasonsForCancellation =  result.paramValue.map(v => Object.values(v)[0]);
        let arrs = [];
        aListOfReasonsForCancellation.forEach(v => {
          arrs.push({ name: v, state: false })
        });
        this.aListOfReasonsForCancellation = arrs;
      }

    },
    async verificationPopUpWindowConfirm(){
      const { result, code } = await this.$store.dispatch("verifyServiceProjectApplyByIdMakeAnAppointmentForService", {
        id: this.verificationListPopUps.id,
      });
      
      if(result == 'success' && code === "0") {
        this.$message({
          message: "核销成功",
          type: "success"
        });
        this.queryList();
      }

      if(result == 'error'  && code === "0"){
        this.$alert(`<strong><p>该客户预约时间为<span>${this.verificationList.subscribeDate}</span>，当前时间尚未到达。</p></strong>`, '核销失败', {
          dangerouslyUseHTMLString: true
        });
      }
      this.verificationPopUpWindow = false;

    },
    getDayOfWeek(dateString) {
        const date = new Date(dateString); // 将字符串转化为 Date 对象
        const daysOfWeek = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        // 获取日期对应的星期几（0-6）
        const dayIndex = date.getDay();
        // 返回星期几的名称
        return daysOfWeek[dayIndex];
    },
    detailSwitchTab() {},
    detailPaging() {},
    detailHandleSizeChange() {},

    // 查看明细详情
    async toDetails(id) {
      const { result } = await this.$store.dispatch(
        "queryServiceProjectFormInputRecord",
        {
          id:id
        }
      );
      let objs = {};
      result.forEach(item => {
        let objsw = {[item.columnName]: item.inputValue };
        objs = {...objs,...objsw};
      });
      this.detailsList = [objs];

      // 生成表头
      this.columns = result.map(item => {
        return {
          label: item.columnName,
          prop: item.columnName
        };
      });

      this.dialogVisible = true;
    },

    // 打开核销弹窗
    verification(row) {
      console.log("row:", row);
      this.verificationListPopUps = row;
      this.verificationPopUpWindow = true;
      // const promptStatus = await this.$confirm("是否确定审核?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // });
      
      // if (promptStatus === "confirm") {
      //   const { result, code } = await this.$store.dispatch("verifyServiceProjectApplyByIdMakeAnAppointmentForService", {
      //     id: ids,
      //   });
        
      //   if(result == 'success' && code === "0") {
      //     this.$message({
      //       message: "核销成功",
      //       type: "success"
      //     });
      //     this.queryList();
      //   }

      //   if(result == 'error'  && code === "0"){
      //     this.$alert(`<strong><p>该客户预约时间为<span>${this.verificationList.subscribeDate}</span>，当前时间尚未到达。</p></strong>`, '核销失败', {
      //       dangerouslyUseHTMLString: true
      //     });
      //   }
        
      // }


      // if (result === "confirm") {
      //   const { code } = await this.$store.dispatch(
      //     "verifyServiceProjectApplyById",
      //     {
      //       id:id
      //     }
      //   );
      //   if(code==='0'){
      //     this.$message({
      //       message: " 核销成功",
      //       type: "success",
      //     });
      //   }
      // }
    },
    AddServiceProject() {
      this.$router.push({ name: "AddServiceProject" });
    },
    async queryServiceRestorationTypeList() {
      const { result } = await this.$store.dispatch(
        "queryServiceRestorationTypeList",
        {}
      );
      if (result) {
        this.serviceTypeList = result;
      }
    },
    async queryList(isFelse) {
      if(isFelse == false){
        this.currentPage = 1;
      }
      if (this.searchCondition.queryDate) {
        this.searchCondition.queryStartDate = this.searchCondition.queryDate[0];
        this.searchCondition.queryEndDate = this.searchCondition.queryDate[1];
      }else {
        this.searchCondition.queryStartDate = '';
        this.searchCondition.queryEndDate = '';
      }
      
      // return false;
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if(searchCondition.shopIdList){
        searchCondition.shopIdList = [searchCondition.shopIdList];
      }else {
        delete searchCondition.shopIdList
      }
      if(searchCondition.employeeIdList){
        searchCondition.employeeIdList = [searchCondition.employeeIdList];
      }else {
        delete searchCondition.employeeIdList
      }

      //  这里处理三级参数传的方式
      if(searchCondition.categorizationServiceDropDown && searchCondition.categorizationServiceDropDown.length > 0){
        searchCondition['serviceTypeId'] = searchCondition.categorizationServiceDropDown[0];
        searchCondition['projectId'] = searchCondition.categorizationServiceDropDown[1];
        searchCondition['timeQuantumId'] = searchCondition.categorizationServiceDropDown[2];
      }
      Object.assign(params, searchCondition);
      this.paramsExport = params;
      const { result } = await this.$store.dispatch(
        "queryServiceProjectApplyRecordList",
        params
      );
      const { records, total } = result;
      this.detailList = records;
      this.total = total;
    },
    // async getServiceRestorationProjectInfo() {
      
    //   const { result } = await this.$store.dispatch(
    //     "getServiceRestorationProjectInfo",
    //     {
    //       id: this.projectId,
    //     }
    //   );
    //   console.log("result:", result);
    //   result.subscribe = [result.subscribeStartDate, result.subscribeEndDate];
    //   result.timeQuantumRelModelList.map((v) => {
    //     v.sort = v.startTimeQuantum.replace(/\:/g, ".");
    //     v.isshow = true;
    //     v.delState = false;
    //   });
    //   this.ruleForm = result;

    //   this.ruleForm.shopRelModelList.forEach((v) => {
    //     v.empRelModelList.forEach((o) => {
    //       this.shopEmpList.push(o);
    //     });
    //   });
    //   console.log("this.ruleForm:", this.ruleForm);
    //   console.log("this.shopEmpList:", this.shopEmpList);
    // },


    // 分类服务
    async getServiceRestorationTypeNodeListByStoreCode(){
      const { result } = await this.$store.dispatch(
        "getServiceRestorationTypeNodeListByStoreCode",{
          storeCode: this.storeCode
        }
      );
      if(result && result.length > 0){
        let resultArrs = JSON.parse(JSON.stringify(result));
        let resultLevel = JSON.parse(JSON.stringify(result));
        resultLevel.forEach(v=>{
          v['label'] = v.serviceType;
          v['value'] = v.id;
          v['children'] = v.projectInfoModelList;
          if(v.children && v.children.length > 0){
            v.children.forEach(o=>{
              o['label'] = o.serviceName;
              o['value'] = o.id;
            })
          }
        })
        resultArrs.forEach(v=>{
          v['label'] = v.serviceType;
          v['value'] = v.id;
          v['children'] = v.projectInfoModelList;
          if(v.children && v.children.length > 0){
              v.children.forEach(o=>{
                o['label'] = o.serviceName;
                o['value'] = o.id;
                o['children'] = o.serviceDateQuantumMaps;
                if(o.children && o.children.length > 0){
                  o.children.forEach(p=>{
                    p['label'] = p.timeQuantum;
                    p['value'] = p.id;
                  })
                }
            })
          }
        })

        this.serviceTypeRelModelList = resultArrs;
        this.resultLevel = resultLevel;
      }
    },
    // 服务门店
    async queryServiceRestorationProjectShopList(){
      const { result } = await this.$store.dispatch(
        "queryServiceRestorationProjectShopListTenant"
      );
      if(result){
        this.ruleForm.shopRelModelList = result;
      }
    },
    // 查询技师姓名
    async queryServiceRestorationProjectEmpList(){
      const { result } = await this.$store.dispatch(
        "queryServiceRestorationProjectEmpListTenant",
        {
          storeCode: this.storeCode,
        }
      );
      if(result){
        this.shopEmpList = result;
      }
    },
    async queryServiceRestorationProjectTimeQuantumList(){
      const { result } = await this.$store.dispatch(
        "queryServiceRestorationProjectTimeQuantumList",
        {
          id: this.projectId,
        }
      );
      if(result){
        console.log("result:",result);
        this.ruleForm.timeQuantumRelModelList = result;
      }
    },
    switchTab() {
      this.serviceProject = [];
      this.currentPage = 1;
      this.pageSize = 10;
      if (this.switchType === "detail") {
        this.queryList();
      } else if (this.switchType === "statistics") {
        this.queryStatisticsList();
      }
    },
    queryTab() {
      this.queryTypeList.forEach(v=>{
        if(v.label===this.queryType){
          this.queryTypeName = v.name;
        }
      })       
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryStatisticsList();
    },
    // 统计列表
    async queryStatisticsList() {
      const params = {
        shopIdList: this.searchCondition.shopIdList?[this.searchCondition.shopIdList]:[],
        projectId: this.projectId,
        queryType: this.queryType,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        shopId: this.searchCondition.shopRelId,
      };
      if(this.searchCondition.resultLevelVal && this.searchCondition.resultLevelVal.length > 0){
        params['serviceTypeId'] = this.searchCondition.resultLevelVal[0];
        params['projectId'] = this.searchCondition.resultLevelVal[1];
      }
      const { result } = await this.$store.dispatch(
        "queryServiceProjectDataStatistics",
        params
      );
      const { records, total } = result;
      this.statisticsList = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导出excel
    // output() {
    //   require.ensure([], () => {
    //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
    //     this.isOutputing = true;
    //     this.queryList()
    //       .then((v) => {
    //         const list = this.detailList;
    //         list.map(v=>{
    //           if(v.serviceStatus === 'success')
    //           {
    //             v.serviceStatus = '已完成'
    //           } else if(v.serviceStatus === 'signUp')
    //           {
    //             v.serviceStatus = '已预约'
    //           } else if(v.serviceStatus === 'overdue')
    //           {
    //             v.serviceStatus = '已过期'
    //           } else if(v.serviceStatus === 'cancel')
    //           {
    //             v.serviceStatus = '已取消'
    //           }
    //           v.timeQuantum = v.startTimeQuantum +'-'+ v.endTimeQuantum
    //         })
    //         const tHeader = [
    //           "会员手机号",
    //           "会员姓名",
    //           "预约单号",
    //           "服务项目",
    //           "预约时间",
    //           "预约时段",
    //           "技师姓名",
    //           "技师手机号",
    //           "服务门店",
    //           "订单状态",
    //         ];
    //         const filterVal = [
    //           "memberMobile",
    //           "memberName",
    //           "serviceSn",
    //           "serviceType",
    //           "subscribeDate",
    //           "timeQuantum",
    //           "realname",
    //           "phone",
    //           "shopName",
    //           "serviceStatus",
    //         ];
    //         const data = this.formatJson(filterVal, list);
    //         exportJsonToExcel(tHeader, data, "活动列表");
    //         this.isOutputing = false;
    //       })
    //       .catch(() => {
    //         this.isOutputing = false;
    //       });
    //   });
    // },


    output() {
      this.isOutputing = true;
      // searchCondition.exportName = "预约列表明细";
      this.$store.dispatch("storeServiceRestorationExport", this.paramsExport);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.isOutputing = false;
      }, 0);
    }, 
  },
};
</script>
<style lang="scss" scoped>
.cancel_box {
  h2 {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    color: rgba($color: #000000, $alpha: 0.5);
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      height: 44px;
      border-radius: 6px;
      border: 1px solid #DDDDDD;
      font-weight: 400;
      font-size: 14px;
      line-height: 44px;
      color: #222222;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 0 13px;
      box-sizing: border-box;
      cursor: pointer;
    }
    li.active {
      border: 1px solid #E50065;
      color: #E50065;
      position: relative;
    }
    li.active::before {
      content: '';
      width: 20px;
      height: 20px;
      background: url('https://redpackge.oss-cn-hangzhou.aliyuncs.com/static/fuwu/red_btn.svg') no-repeat center center;
      background-size: 100% 100%;
      display: inline-block;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    textarea {
      color: rgba(0,0,0,0.6);
      border-radius: 6px;
      outline: none; 
      padding: 10px;
      box-sizing: border-box;
      border: 1px solid #DDDDDD;
    }
  }
}
.verification {
  padding: 0 20px;
  h3 {
    font-size: 16px;
    color: red;
  }
  .table {
    margin-top: 13px;
    display: flex;
    flex-wrap: wrap;
    .list {
      width: 340px;
      background: #FBFDFF;
      border-radius: 8px;
      border: 1px solid #DFDFDF;
      padding: 10px;
      box-sizing: border-box;
      margin-right: 22px;
      margin-bottom: 22px;
      cursor: pointer;
      .list_title {
        width: 100%;
        height: 32px;
        border-bottom: 1px solid #EAEAEA;
        align-items: center;
        h3 {
          height: 22px;
          font-weight: 500;
          font-size: 15px;
          color: rgba(0,0,0,0.8);
          line-height: 21px;
        }
      }
      .name_mobile {
        align-items: center;
        margin-top: 4px;
        p {
          height: 22px;
          font-weight: 500;
          line-height: 21px;
        }
        .username {
          font-size: 15px;
          color: rgba(0,0,0,0.8);
          margin-right: 5px;
        }
        .cellPhone {
          font-size: 13px;
          color: #000000;
        }
      }
      .number {
        height: 22px;
        font-weight: 400;
        font-size: 13px;
        color: #949494;
        line-height: 21px;
      }
      .time {
        height: 22px;
        font-weight: 500;
        font-size: 15px;
        color: #0862EC;
        line-height: 21px;
      }
      img {
        width: 15px;
        height: 16px;
        margin-right: 5px;
      }
      ul {
        width: 100%;
        height: 51px;
        background: #F3F3F3;
        border-radius: 4px;
        display: flex;
        align-items: center;
        li {
          width: 25%;
          .th {
            width: 80px;
            height: 17px;
            font-weight: 600;
            font-size: 13px;
            color: rgba(0,0,0,0.9);
            line-height: 17px;
            text-align: center;
            margin-bottom: 6px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .tr {
            height: 16px;
            font-weight: 500;
            font-size: 12px;
            color: #949494;
            line-height: 14px;
            text-align: center;
          }
        }
      }
    }
    .list.active {
      border: 1px solid #0862EC;
      ul {
        background: #E0EDFF;
      }
    }
  }
}
</style>
